import {createSlice} from '@reduxjs/toolkit';
import {metrics} from '~/vendor/metrics';

const initialState = {
  lowResIcons: {}
};

/**
 * The analytics reducer is old and bloated, please migrate existing actions to
 * this slice.
 */

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    // limit tag to fire once per upload per session
    fireLowResMetric: (state, action) => {
      const iconId = action.payload;
      if (!state.lowResIcons[iconId]) {
        state.lowResIcons[iconId] = true;
        metrics.fireEvent('/ndx/upload/low-res-warning');
      }
    }
  }
});

export const {fireLowResMetric} = metricsSlice.actions;
export default metricsSlice.reducer;
